import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { TemplateQuestion } from "../../../@types/templateQuestion";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const updateTemplateData = createAsyncThunk(
  "templateDetail/updateTemplateData",
  async (data, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const { id: templateId, name, richText, assignedTo, } = state.templateDetail.template;
      const questionList = state.templateDetail.questionList;
      let questionResponseList: TemplateQuestion[] = [];

      const { data: templateResponse } = await axiosInstance.patch(`${api.baseURL}form/${templateId}`, {
        name,
        richText,
        assignedTo,
      });

      for (const { order, label, type, id, category, template, legalRepresentative, signatureProvider } of questionList) {
        const categoryId = category?.id;
        if (id) {
          const { data } = await axiosInstance.patch(`${api.baseURL}formquestion/${id}`, {
            label,
            order,
            type,
            category: categoryId,
            template: template?.id,
            signatureProvider: signatureProvider?.id,
            legalRepresentative: legalRepresentative?.id,
          });
          questionResponseList.push(data);
        } else {
          const { data } = await axiosInstance.post(`${api.baseURL}formquestion`, {
            label,
            form: templateId,
            order,
            type,
            category: categoryId,
            template: template?.id,
            signatureProvider: signatureProvider?.id,
            legalRepresentative: legalRepresentative?.id,
          });
          questionResponseList.push(data);
        }
      }

      return { success: true, questionResponseList, templateResponse };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
